import { Box } from "@mui/material";
import React from "react";
import MainNavigation from "./Gene20Navigation/MainNavigation";

const Layout = (props) => {
  const { darkMode, setDarkMode } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <Box>
      <MainNavigation
        handleDrawerToggle={handleDrawerToggle}
        mobileOpen={mobileOpen}
        darkMode={darkMode}
        setDarkMode={setDarkMode}
      />
      <Box component="main" sx={{ mt: "10vh" }}>
        {props.children}
      </Box>
    </Box>
  );
};

export default Layout;
